import {
    IRIS_RETURNS_CONTENT_REQUEST,
    IRIS_CONTENT_GET_REQUEST,
} from '../actionTypes/ProductContentActionTypes';

export const getIrisReturnsContent = (payload) => ({
    type: IRIS_RETURNS_CONTENT_REQUEST,
    payload,
});

export const getIrisContent = (payload) => ({
    type: IRIS_CONTENT_GET_REQUEST,
    payload,
});
